import {
  Button,
  DialogCloseButton,
  Popover,
  Stack,
  Typography,
} from "@hiver/hiver-ui-kit";
import { useState } from "react";
import SVG from "react-svg-inline";
import ConversationFilterPanelImage from "../../images/conversation-filter-panel.png";
import HiverLogo from "../../images/hiver-logo-LFD.svg";
import { getFilterGuiderLocalKey, setFilterGuiderLocalKey } from "./utils";

const FilterPopoverGuider = () => {
  const anchorEl = document.getElementById("conversation-filter-button");
  const [open, setOpen] = useState(true);
  const onClose = () => {
    setOpen(false);
    setFilterGuiderLocalKey();
  };

  if (!anchorEl || getFilterGuiderLocalKey()) return null;
  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: "274px",
            padding: "16px",
          },
        },
      }}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
    >
      <DialogCloseButton onClick={onClose} />
      <Stack>
        <img
          src={ConversationFilterPanelImage}
          alt="Conversation Filter Panel"
          style={{
            width: "100%",
            height: "170px",
          }}
        />
        <Typography variant="body1_medium">
          Use the filter panel to narrow down your search results.
        </Typography>
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 2,
          }}
        >
          <SVG alt={"Hiver Logo"} svg={HiverLogo} width="58px" height="24px" />
          <Button size="small" onClick={onClose}>
            Got it
          </Button>
        </Stack>
      </Stack>
    </Popover>
  );
};

export default FilterPopoverGuider;
